export default __webpack_public_path__ + "static/media/card-img-overlay.081ee2c3.jpg";